export default __webpack_public_path__ + "static/hero_2-26c06a92662c7a97ce436dfa3489aca0.jpg";